import React from 'react';

import Popup from '../../Popup';
import styles from './welcomePopUps.scss';

const WelcomePopUp = (props) => {
    const { popupClass, welcomeTitles, onCloseClick, onCtaClick, dangerouslySetInnerHTML } = props;

    return (
        <Popup
            className={popupClass || `popup-md`}
            popUpClassName={`${styles.welcomePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
        >
            {(welcomeTitles.title || welcomeTitles.subTitle) && (
                <div className={`${styles.section} pt0`}>
                    <h4>
                        {`${welcomeTitles.title || ''}`}
                        <span className="d-block">
                            {`${welcomeTitles.subTitle || ''}`}
                        </span>
                    </h4>
                </div>
            )}

            <div className={`${styles.section} pt0`}>
                { dangerouslySetInnerHTML === true && (
                    <p dangerouslySetInnerHTML={{ __html: welcomeTitles.description }} />
                )}

                {dangerouslySetInnerHTML !== true && (
                    <p>
                        {`${welcomeTitles.description}`}
                    </p>
                )}

                <div className="bb" />
                <button
                    type="button"
                    className="btn btn-primary btn-xl btn-block text-uppercase"
                    onClick={onCtaClick}
                >
                    Got It
                </button>
            </div>
        </Popup>
    );
};

export default WelcomePopUp;
